
var BrowserPushNotification = function (options, ready) {
  this.init(options, ready);
};

jQuery.extend(BrowserPushNotification.prototype, {

    firebaseConfig : {
        apiKey: "AIzaSyAfGAMtxQudKojuVl4znhKrqLlQSiEV80M",
        authDomain: "simplybook-web-push.firebaseapp.com",
        databaseURL: "https://simplybook-web-push.firebaseio.com",
        storageBucket: "simplybook-web-push.appspot.com",
        messagingSenderId: "1031836595876"
    },


    options : {
        //https://web-push-codelab.appspot.com/
        is_user_public : false,
        worker_path : '/v2/js/push-notifications/sw.js',
        worker_version : 4,
        worker_scope : '/',
        register_worker : true,
        tokens : [],
        content_policy_nonce: '',
    },

   // swRegistration : null,
    //isSubscribed : false,
    messaging : null,
    config : null,
    token : null,
    worker: {
        isRegistered : false
    },

    init : function (opts, ready) {
        var _this = this;
        this.options = jQuery.extend(this.options, opts);

        if(window.web_tokens){
            this.options.tokens = jQuery.merge(this.options.tokens, window.web_tokens);
        }

        if(typeof isUserPublic != 'undefined'){
            this.options.is_user_public = isUserPublic;
        }


        //console.log(_this.options);

        this.loadJsFile( 'https://www.gstatic.com/firebasejs/3.6.1/firebase-app.js', function() {
            _this.loadJsFile('https://www.gstatic.com/firebasejs/3.6.1/firebase-messaging.js', function () {
                firebase.initializeApp(_this.firebaseConfig);
                _this.messaging = firebase.messaging();
                if(typeof ready == 'function'){
                    ready();
                }

                if(_this.options.register_worker) {
                    _this.checkWorkerVersion();
                }
            });
        });
    },

    loadJsFile : function (url, callback) {
        var script = document.createElement('script');
        script.onload = function () {
            if(callback){
                callback();
            }
        };
        script.src = url;
        if(this.options.content_policy_nonce) {
            script.nonce = this.options.content_policy_nonce;
        }
        document.head.appendChild(script);
    },


    //
    // loadJsFile : function (url, callback) {
    //     var _this = this;
    //
    //     console.log(_this.options.content_policy_nonce);
    //
    //     jQuery.ajax({
    //         url: url,
    //         dataType: "script",
    //         async: true,
    //         scriptAttrs: {
    //             nonce: _this.options.content_policy_nonce,
    //         },
    //     }).done(function() {
    //         callback();
    //     });
    // },

    initEvents : function () {

    },


    initPush : function ( callback ) {
        var _this = this;
/*
        if(this.token){
            if(typeof callback == 'function'){
                callback(true, this.token);
            }
        } else*/
        if(_this.messaging){
            this._subscribe(function (isSubscribed, isBlocked) {
                if(isSubscribed){
                    _this._getToken(function (token) {
                        _this.token = token;
                        _this.options.tokens.push(token);

                        if(typeof callback == 'function'){
                            callback(true, token);
                        }
                    });
                } else{
                    if(typeof callback == 'function'){
                        callback(false, null, isBlocked);
                    }
                }
            });
        }
    },

    _subscribe : function (callback) {
        var _this = this;

        _this.isSubscribed(function (pushStatus) {
            if(pushStatus){
                callback(true);
            } else {
                _this.messaging.requestPermission().then(function() {
                    //console.log('Notification permission granted.');
                    callback(true);
                })
                .catch(function(err) {
                    console.log('Unable to get permission to notify.', err);
                    callback(false, true);
                });
            }
        });


    },


    _getToken : function (callback) {
        var _this = this;

        this.registerWorker(function (workerReg) {
            if(!_this.options.isWorkerRegistered){
                _this.messaging.useServiceWorker(workerReg);
                _this.options.isWorkerRegistered = true;
            }

            if(_this.token){
                if(typeof callback == 'function'){
                    callback(_this.token);
                }
            } else {
                _this.messaging.getToken().then(function(currentToken) {
                    if (currentToken) {
                        _this.token = currentToken;
                        if(typeof callback == 'function'){
                            callback(currentToken);
                        }
                    } else {
                        console.log('No _this ID token available. Request permission to generate one.');
                    }
                }).catch(function(err) {
                    console.log('An error occurred while retrieving token. ', err);
                    //showToken('Error retrieving _this ID token. ', err);
                    //setTokenSentToServer(false);
                });
            }

        });
    },

    checkWorkerVersion : function(){
        var _this = this;

        // if('localStorage' in window) {
        //     var serviceWorkerVersion = localStorage.getItem('serviceWorkerVersion');
        //
        //     if(!serviceWorkerVersion || parseInt(this.options.worker_version) !== parseInt(serviceWorkerVersion)) {
        //         console.log('Update service worker');
                this.registerWorker(function (registration) {
                    //registration.update();
                });
        //         localStorage.setItem('serviceWorkerVersion', this.options.worker_version);
        //     }
        // }
    },

    isWorkerRegistered : function(callback){
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                //console.log(registrations);
                if(registrations && registrations.length){
                    callback(registrations[0]);
                }
            });
        }
    },

    registerWorker : function (callback) {
        var _this = this;

        if(this.options.register_worker) {

            if ('serviceWorker' in navigator && 'PushManager' in window) {
                // console.log('Service Worker and Push is supported');

                var isWorkerRegistered = false;

                var regWorker = function () {
                    if(!isWorkerRegistered){
                        navigator.serviceWorker.register(_this.options.worker_path + '?v=' + _this.options.worker_version, {
                            //scope: _this.options.worker_scope
                        }).then(function (registration) {
                            console.log('Service Worker is registered', registration);
                            _this.swRegistration = registration;
                            callback(registration);
                        }).catch(function (err) {
                            console.log('Service Worker Error', err);
                        });
                    }
                };

                navigator.serviceWorker.getRegistration(this.options.worker_path).then(function (registration) {
                    if(registration) {
                        if (registration.active) {
                            var version = registration.active.scriptURL.split('?v=')[1];

                            if (version && parseInt(version) === parseInt(_this.options.worker_version)) {
                                console.log('Worker is registered and up to date');
                                isWorkerRegistered = true;
                                callback(registration);
                            } else if (version && parseInt(version) !== parseInt(_this.options.worker_version)) {
                                registration.unregister();
                            }
                        } else {
                            registration.unregister();
                        }
                    }
                    regWorker();
                });


            } else {
                console.warn('Push messaging is not supported');
            }
        } else {
            this.isWorkerRegistered(function (registration){
                //console.log(registration);

                _this.swRegistration = registration;
                callback(registration);
            });
        }
    },
    
    unsubscribe : function (callback) {
        var _this = this;
        _this.options.tokens = [];
        callback();
/*        if ('serviceWorker' in navigator && 'PushManager' in window) {
            _this.options.tokens = [];
            navigator.serviceWorker.getRegistration(this.options.worker_path).then(function(registration) {
                if(registration){
                    registration.unregister().then(function () {
                        callback();
                    });
                }
            });
        } else {
            console.warn('Push messaging is not supported');
        }*/
    },

    isBlocked : function (callback) {
        var _this = this;
        if(_this.messaging){
            _this.messaging.requestPermission().then(function() {
                callback(false);
            })
            .catch(function(err) {
                callback(true);
            });
        }
    },
    
    
    isSubscribed : function (callback, ignoreTokenList) {
        var _this = this;
        var pushStatus = Notification.permission == "granted";

        if(pushStatus){
            this._getToken(function (token) {
                _this.token = token;

                //console.log(token);

                //console.log(_this.options.tokens, token, _this.options.tokens.indexOf(token) != -1);

                if(ignoreTokenList){
                    callback(!!token, token);
                } else {
                    var isSubscribed = _this.options.tokens.indexOf(token) != -1;
                    if(isSubscribed){
                        callback(true, token);
                    } else {
                        callback(false);
                    }
                }
            });
        } else{
            callback(false);
        }


    }



});

define("notification", ["jquery"], function(){});

